<template>
  <div class="h-full">
    <div class="bottom_space rounded py-2 h-full bg-white">
      <div class="pt-1">
        <div class="pb-2" v-if="IsSuperAdmin">
          <button class="mr-3 text-sm border  hover:bg-info py-2.5 text-text1 rounded-md list_btn" :class="statusVal ? 'bg-info border-info' : 'bg-white border-gray-500'" @click="statusChip('active')">Active</button>
          <button class="mr-3 text-sm border  hover:bg-info py-2.5  text-text1 rounded-md list_btn" :class="!statusVal ? 'bg-info border-info' : 'bg-white border-gray-500'" @click="statusChip('inactive')">Inactive</button>
        </div>
      </div>
      <div class="bottom_space flex justify-between">
          <div class="mb-2 flex">
            <div class="max-w-max mr-4">
              <div class="select_button text-sm text-gray3">
              <SimpleDropdown :dropdownList="items" @callApiAsperSelectValue1="getLeaveDataAsPerPagination1"/>
              </div>
            </div>
            <div style="display:flex" class="search_customer_box  text-gray-500 bg-white border border-gray-500 rounded-md text-sm px-2 py-1 items-center h-11">
              <span class="mr-2 cursor-pointer"><img height="20px" width="20px" src="@/assets/images/svg/gray-search.svg" alt=""></span>
              <input class="focus:outline-none w-72" type="text" name="" placeholder="Search" id="custSearchInput"
                v-model="searchForCustomer"
                @input="getContactListDeboucne"
              >
              <span v-if="searchForCustomer.length > 0" class="cursor-pointer"><img @click="clearSearch()" height="12px" width="12px" src="@/assets/images/svg/clear-input.svg" alt="clearInput"></span>
            </div>
          </div>
          <div class="flex">
            <div v-if="showLoader" class="flex items-center">
              <div class="loader"></div>
              <p class="cta-text text-primary font-bold py-3 px-4 pl-2 mr-2">Build is running</p>
            </div>
            <div v-if="showError" class="group flex text-error font-bold py-3 px-5 rounded-3xl mr-2 border border-error">
              <span><i class="fas fa-times pr-1"></i></span>
              <span>Build Failed</span>
            </div>
            <div v-if="showError" class="w-48">
              <button class="bg-error cta-text text-white font-bold py-3 px-5 rounded-3xl mr-2" @click="rebuildWebsite()">Re-build Website</button>
            </div>
            <div v-if="buildSuccess" class="w-48">
              <button class="bg-info cta-text text-text1 font-bold py-3 px-5 rounded-3xl mr-2" @click="rebuildWebsite()">Re-build Website</button>
            </div>
            <div v-if="IsSuperAdmin">
              <button class="list_top_card_btn bg-primary cta-text text-white py-3 px-5 font-bold rounded-3xl" @click="addUserPopup('0')">Create Page</button>
            </div>
          </div>
        </div>
        <div v-if="buildSuccess">
          <p class="text-right text-text2 font-bold -mt-3 mr-44">Last Build: <span class="text-text2 font-bold"> {{lastBuildDate | dateTimeFilter}}</span> </p>
        </div>
      <div>
      <div class="w-full">
        <div class="progress-bar" v-if="searchLoader">
          <div class="progress-bar-value"></div>
        </div>
      </div>
      <div style="overflow-y: auto; white-space: nowrap;" class="table_containder " v-if="!mobileView">
        <div class="text-text2  min-w-min heaer_row border border-gray1 font-bold flex heading-5 px-3 py-3 items-center">
          <div class="id_col flex items-center p-2">
            <span class="cursor-pointer" @click="sortByColumn(0)">{{titleObj[0].title}} </span>
            <img v-if="titleObj[0].sortVal === 'DESC'" src="@/assets/images/svg/DESC.svg" /> 
            <img v-if="titleObj[0].sortVal === 'ASC'" src="@/assets/images/svg/ASC.svg" /> 
          </div>
          <div class="name_col  flex items-center p-2">
            <span class="cursor-pointer" @click="sortByColumn(1)">{{titleObj[1].title}}</span>
            <img class="pl-1" v-if="titleObj[1].sortVal === 'DESC'" src="@/assets/images/svg/DESC.svg" /> 
            <img class="pl-1" v-if="titleObj[1].sortVal === 'ASC'" src="@/assets/images/svg/ASC.svg" /> 
          </div>
          <div class="cell_col  flex items-center p-2">
            <span class="cursor-pointer" @click="sortByColumn(2)">{{titleObj[2].title}}</span>
            <img class="pl-1" v-if="titleObj[2].sortVal === 'DESC'" src="@/assets/images/svg/DESC.svg" /> 
            <img class="pl-1" v-if="titleObj[2].sortVal === 'ASC'" src="@/assets/images/svg/ASC.svg" /> 
          </div>
          <div class="cell_col  flex items-center p-2">
            <span class="cursor-pointer" @click="sortByColumn(3)">{{titleObj[3].title}}</span>
            <img class="pl-1" v-if="titleObj[3].sortVal === 'DESC'" src="@/assets/images/svg/DESC.svg" /> 
            <img class="pl-1" v-if="titleObj[3].sortVal === 'ASC'" src="@/assets/images/svg/ASC.svg" /> 
          </div>
        </div>
        <div v-for="(data, index) in employeeList" :key="index" class="min-w-min group   flex border-r border-l border-b border-gray1  bg-white  text-sm px-3 py-2 items-center cursor-pointer hover:bg-gray-50">
          <div class="id_col p-2">
            <span class="heading-4  text-text2 font-medium">{{data.pageMasterId}}</span>
          </div>
          <div class="name_col p-2">
            <span class="heading-4  text-primary font-medium cursor-pointer" @click="gotoPageDetail(data)">{{data.pageName}}</span>
          </div>
          <div class="cell_col p-2">
            <span class="heading-4 text-text2" v-if="data.updatedDate !== ''">{{data.updatedDate | dateTimeFilter}}</span>
            <span class="" v-else>--</span>
          </div>
          <div class="cell_col p-2">
            <span class="heading-4 text-text2" v-if="data.updateByFirstName !== ''">{{data.updateByFirstName}} {{data.updateByLastName}}</span>
            <span class="" v-else>--</span>
          </div>
          <div class="p-2 absolute right-5" v-if="IsSuperAdmin">
            <div class="">
              <!-- <span class="px-1 pr-3 cursor-pointer" @click="addUserPopup(data.pageMasterId)">
                <i class="fas fa-edit text-primary h-5 w-5" ></i>
              </span> -->
              <!-- <span class="px-1 pr-3 cursor-pointer" @click="addUserPopup(data.projectDetailId)">
                <i class="fa-solid fa-ellipsis-vertical text-text2 h-5 w-5"></i>
              </span> -->
              <span class="ml-2 mr-2 p-1 text-gray4  heading-1 cursor-pointer"  @click.stop.passive="opendata(data.pageMasterId)">
                <i class="fas fa-ellipsis-v"></i>
              </span>
              <div>
                <div v-click-outside="closeCopyDeleteMenu">
                  <div v-if="data.isOpen" class=" bg-white absolute z-10 right-3 shadow-2xl rounded -top-7">
                    <div style="max-width: fit-content;" class="">
                      <div class="p-2 text-text1 ">
                        <div class="px-4 py-3 cursor-pointer hover:bg-blue-50" @click="dublicate(data)">
                          <!-- <i class="fas fa-copy h-4 w-4 pr-3 text-primary"></i> -->
                          <span class="heading-4 py-1">Duplicate Page</span>
                        </div>
                        <div class="px-4 py-3 cursor-pointer hover:bg-blue-50" @click="addUserPopup(data.pageMasterId)">
                          <!-- <i class="fas fa-edit h-4 w-4 pr-3 text-primary"></i> -->
                          <span class="heading-4 py-1">Update Page Structure</span>
                        </div>
                        <div class="px-4 py-3 cursor-pointer hover:bg-red-50" @click="deletePage(data)">
                          <!-- <i class="fas fa-trash h-4 w-4 pr-3 text-error"></i> -->
                          <span class="heading-4 py-1 text-error">Delete Page</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="layout my-2" v-if="employeeList.length === 0">
        <div class="flex p-3 text-sm text-primary bg-blue-100 rounded-lg  items-center" role="alert">
          <svg aria-hidden="true" class="flex-shrink-0 inline w-6 h-6 mr-3" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clip-rule="evenodd"></path></svg>
          <span class="sr-only">Info</span>
          <div>
            <p class=" font-medium heading-4">No record found.</p>
          </div>
        </div>
      </div>
    </div>
    <div class="pt-2">
      <Pagination
        :totalDataCount="totalEmpCount"
        :resetPagination="resetPaginationValues"
        @callApiAsPerPagination="getCustomerDataFromPagination"/>
    </div>
  </div>
  <div v-if="deleteSpecPage" class="popup_overlay">
    <div style="height: 120px; width: 500px;" class="custom_dialog">
      <div class="text-text1 px-4 py-3 flex justify-between items-center">
        <span class="heading-3">Are You Sure ?</span>
        <div class="flex justify-end">
          <button class="bg-error text-white shadow mr-2 rounded-full px-5 py-1.5" @click="deleteSpecPage = false">No</button>
          <button class="bg-primary shadow text-white rounded-full px-5 py-1.5" @click="removePage()">Yes</button>
        </div>
      </div>
      <hr>
      <div class="p-4">
        <p class="text-gray3 heading-4">Once delete cannot be undone !</p>
      </div>
    </div>
  </div>
</div>
</template>
<script>
import HRMAPI from '@/View/CMS/api/HRM.js'
import { getBuildDetail, getBuildList, reBuildProject } from '@/View/CMS/droneApi/api.js'
import SimpleDropdown from '@/View/components/simpleDropdown.vue'
// import Pagination from '@/View/components/pagination.vue'
import Pagination from '@/View/components/pagination.vue'
import {FilterPermissions} from '@/utils/Permissions.js'
import deboucneMixin from '@/mixins/debounce.js'
import HRM from '@/View/CMS/api/HRM.js'
export default {
  components: {
    Pagination,
    SimpleDropdown,
  },
  mixins: [deboucneMixin],
  data () {
    return {
      lastBuildDate: '',
      showError: false,
      buildSuccess: false,
      showLoader: false,
      buildDetail: {},
      specifiSelDetail: [],
      deleteSpecPage: false,
      IsSuperAdmin: false,
      showDetailPopup: false,
      userDetailValue: [],
      mobileView: false,
      istrue: true,
      userDetailId: 0,
      filterApplied: false,
      statusVal: true,
      navigationDialog: false,
      isFilterApplied: false,
      searchLoader: false,
      resetPaginationValues: false,
      showCustomerAddDialog: false,
      searchForCustomer: '',
      titleObj: [
        {title: 'Page Id', icon: '', sortName: 'pageMasterId', sortVal: ''},
        {title: 'Page Title', icon: '', sortName: 'pageName', sortVal: ''},
        {title: 'Last Updated On', icon: 'fas fa-sort-amount-up', sortName: 'updatedDate', sortVal: 'DESC'},
        {title: 'Updated By', icon: '', sortName: 'updateByLastName', sortVal: ''},
    ],
      cancelFilter: {
        selectedBranch: [],
        selectedDepartment: []
      },
      filterObject: {
        start: 0,
        length: 20,
        searchVal: '',
        sortBy: 'updatedDate',
        sortOrder: 'DESC',
        isActive: true,
      },
      totalEmpCount: 0,
      paginationLength: 1,
      filterCol: 'text-gray-400',
      page: 1,
      items: [20, 25, 30, 50, 100],
      limitResData: 20,
      paginationData: 20,
      employeeList: [],
      canAdd: FilterPermissions('customer_account__add_new'),
      retryInterval: null
    }
  },
  created() {
    window.addEventListener("resize", this.resizeWindowHandler);
  },
  mounted () {
    this.getProjectDetail();
    let Isadmin =  JSON.parse(localStorage.getItem('employeeData1'))
    this.IsSuperAdmin = Isadmin.isSuperAdmin
    localStorage.setItem('projectId', parseInt(this.$route.params.projectId))
    console.log(' parseInt(this.$route.params.projectId)',  parseInt(this.$route.params.projectId))
    this.resizeWindowHandler();
    document.title = 'Pages list'
    this.getContactListDeboucne = this.debounce(function () {
      this.resetPaginationValues = true
    }, 500)
    this.getEmployeeList()
    this.getDroneDetail(true)
  },
  watch: {
    searchForCustomer: {
      handler () {
        if (this.searchForCustomer === null) {
          this.searchForCustomer = ''
        }
      }
    },
    titleObj: {
      handler () {
        console.log('titleObj 123', this.titleObj)
      }
    },
    filterApplied: {
      handler () {
        console.log('filterApplied 123', this.filterApplied)
        if (this.filterApplied === true) {
          this.filterCol = 'text-primary'
        } else {
          this.filterCol = 'text-success'
        }
      }
    },
    paginationData: {
      handler () {
        this.filterObject.length = this.paginationData
        this.showlistLoader = true
        this.getEmployeeList(this.showlistLoader)
      },
      deep: true
    }
  },
  methods: {
    opendata (data) {
      console.log(data)
      this.employeeList.forEach(element => {
        if ( element.pageMasterId === data) {
          element.isOpen = true
        } else {
          element.isOpen = false
        }
      });
    },
    closeCopyDeleteMenu () {
      for (let index = 0; index < this.employeeList.length; index++) {
        this.employeeList[index].isOpen = false
      }
    },
    resizeWindowHandler() {
      if (window.innerWidth < 684) {
        this.mobileView = true;
      } else {
        this.mobileView = false;
      }
    },
    addUserPopup (index) {
      this.$router.push({name: 'EditPage', params: {projectId: parseInt(this.$route.params.projectId), pageMasterId: index}})
    },
    deletePage (data) {
      console.log('data', data)
      this.deleteSpecPage = true
      this.specifiSelDetail = data
    },
    getDroneDetail(isLoader) {
      if (isLoader) {
        this.$store.dispatch('SetLoader', {status: true, message: 'Loading...'})
      }
      getBuildDetail(this.$route.params.projectId).then(response => {
        console.log('123response', response.Data)
        this.buildDetail = response.Data
        if (response.Data.branch !== '' && response.Data.token !== '' && response.Data.nameSpace !== '' && response.Data.name !== '') {
          this.getBuildInfo (response.Data)
        }
      })
      this.$store.dispatch('SetLoader', {status: false, message: 'Loading...'})
    },
    scheduleRetry() {
      if (!this.retryInterval) {
        this.retryInterval = setInterval(() => {
          this.getDroneDetail(false)
        }, 15000)
      }
    },
    clearRetry() {
      if (this.retryInterval) {
        clearInterval(this.retryInterval)
        this.retryInterval = null
      }
    },
    getBuildInfo (data) {
      console.log('datadatadatadata', data)
      this.$store.dispatch('SetLoader', {status: true, message: 'Loading...'})
      getBuildList(data.name, data.nameSpace, data.token).then(response => {
        console.log('getBuildInfo', response)
        if (response[0].status === 'success') {
          var myDate = new Date( 1000 *response[0].finished);
          this.lastBuildDate = myDate.toString()
          this.buildSuccess = true
          this.showError = false
          this.showLoader = false
          this.clearRetry()
          console.log('clearRetry - success')
        } else if (response[0].status === 'failure') {
          this.buildSuccess = false
          this.showError = true
          this.showLoader = false
          this.clearRetry()
          console.log('clearRetry - failure')
        } else {
          this.buildSuccess = false
          this.showError = false
          this.showLoader = true
          this.scheduleRetry()
          console.log('scheduleRetry - runing')
        }
      })
      this.$store.dispatch('SetLoader', {status: false, message: 'Loading...'})
    },

    // getBuildInfo(data) {
    //   console.log('datadatadatadata', data)
    //   this.$store.dispatch('SetLoader', {status: true, message: 'Loading...'})

    //   const startTime = Date.now()
    //   const intervalTime = 15000 // check every 15 seconds

    //   const intervalId = setInterval(() => {
    //     getBuildList(data.name, data.nameSpace, data.token).then(response => {
    //       console.log('Contineous getBuildInfo', response)

    //       if (response && response[0]) {
    //         const status = response[0].status
    //         if (status === 'success') {
    //           var myDate = new Date(1000 * response[0].finished)
    //           this.lastBuildDate = myDate.toString()
    //           this.buildSuccess = true
    //           this.showError = false
    //           this.showLoader = false
    //           clearInterval(intervalId)
    //         } else if (status === 'failure') {
    //           this.buildSuccess = false
    //           this.showError = true
    //           this.showLoader = false
    //           clearInterval(intervalId)
    //         } else {
    //           this.buildSuccess = false
    //           this.showError = false
    //           this.showLoader = true
    //         }
    //       }

    //       if (Date.now() - startTime > 240000) { // 4 minutes = 240000ms
    //         console.log('getBuildInfo timeout after 4 minutes.')
    //         this.buildSuccess = false
    //         this.showError = false
    //         this.showLoader = true
    //         clearInterval(intervalId)
    //       }
    //     }).catch(error => {
    //       console.error('getBuildInfo error', error)
    //       this.buildSuccess = false
    //       this.showError = true
    //       this.showLoader = false
    //       clearInterval(intervalId)
    //     })
    //   }, intervalTime)
    //   this.$store.dispatch('SetLoader', {status: false, message: 'Loading...'})
    // },
    rebuildWebsite () {
      this.$store.dispatch('SetLoader', {status: true, message: 'Loading...'})
      reBuildProject(this.buildDetail.branch, this.buildDetail.name, this.buildDetail.nameSpace, this.buildDetail.token).then(response => {
        console.log('rebuildWebsite', response)
        this.buildSuccess = false
        this.showError = false
        this.showLoader = true
        this.getBuildInfo (this.buildDetail)
      })
      this.$store.dispatch('SetLoader', {status: false, message: 'Loading...'})
    },
    removePage () {
      this.deleteSpecPage = false
      this.$store.dispatch('SetLoader', {status: true, message: 'Loading...'})
      HRMAPI.deleteSpecificPage(
        this.specifiSelDetail.projectDetailId,
        this.specifiSelDetail.pageMasterId,
        response => {
          console.log("response 1233", response.Data)
          this.$store.dispatch('SetLoader', {status: false, message: ''})
          this.$store.dispatch('SetAlert', {showAlert: true, message: response.message, color: 'success'})
          this.getEmployeeList()
        },
        error => {
          this.$store.dispatch('SetLoader', {status: false, message: ''})
          this.$store.dispatch('SetAlert', {showAlert: true, message: error.message, color: 'error'})
        }
      )
    },

    dublicate (data) {
      console.log('data', data)
      this.$store.dispatch('SetLoader', {status: true, message: 'Loading...'})
      HRMAPI.duplicatePage(
        data.projectDetailId,
        data.pageMasterId,
        response => {
          console.log("response 1233", response.Data)
          this.$store.dispatch('SetLoader', {status: false, message: ''})
          this.getEmployeeList()
          this.$router.push({name: 'specificPageDetailInPage', params: {projectId: data.projectDetailId, pageMasterId: response.Data}})
          this.$store.dispatch('SetAlert', {showAlert: true, message: response.message, color: 'success'})
        },
        error => {
          this.$store.dispatch('SetLoader', {status: false, message: ''})
          this.$store.dispatch('SetAlert', {showAlert: true, message: error.message, color: 'error'})
        }
      )
    },
    gotoPageDetail (data) {
      this.$router.push({name: 'specificPageDetailInPage', params: {projectId: data.projectDetailId, pageMasterId: data.pageMasterId}})
    },
    clearSearch () {
      this.searchForCustomer = ''
      this.searchLoader = false
      this.getEmployeeList()
    },
    getCustomerDataFromPagination (data) {
      this.filterObject.start = data.offset
      this.filterObject.length = data.limit
      let showlistLoader = false
      if (data.offset !== 0) {
        showlistLoader = true
      }
      this.getEmployeeList(showlistLoader)
    },
    sortByColumn (index) {
      for (let i = 0; i < this.titleObj.length; i++) {
        if (i === index) {
          if (this.titleObj[i].icon === '') {
            this.titleObj[i].icon = 'fas fa-sort-amount-down'
            this.titleObj[i].sortVal = 'DESC'
            this.filterObject.sortOrder = 'DESC'
          } else if (this.titleObj[i].icon === 'fas fa-sort-amount-down') {
            this.titleObj[i].icon = 'fas fa-sort-amount-up'
            this.titleObj[i].sortVal = 'ASC'
            this.filterObject.sortOrder = 'ASC'
          } else {
            this.titleObj[i].icon = 'fas fa-sort-amount-down'
            this.filterObject.sortOrder = 'DESC'
            this.titleObj[i].sortVal = 'DESC'
          }
        } else {
          this.titleObj[i].icon = ''
          this.titleObj[i].sortVal = ''
        }
      }
      this.filterObject.sortBy = this.titleObj[index].sortName
      this.getEmployeeList(true)
    },
    redirectToDetail (employeeId) {
      if (FilterPermissions('employee__detail_view')) {
        this.$router.push({name: 'EmployeeDetail', params: {employeeId: employeeId}})
      }
    },
    toTop () {
      this.$vuetify.goTo(0)
    },
    statusChip (val) {
      console.log(val)
      if (val === 'active') {
        this.statusVal = true
        this.filterObject.isActive = true
      } else if (val === 'inactive') {
        this.statusVal = false
        this.filterObject.isActive = false
      }
      this.getEmployeeList()
    },
    getLeaveDataAsPerPagination1 (data) {
      this.filterObject.length = data
      this.getEmployeeList()
    },
    getProjectDetail() {
      this.$store.dispatch('SetLoader', {status: true, message: 'Please Wait...'})
      HRM.getSpecProjectDetail(
        JSON.parse(this.$route.params.projectId),
        response => {
          console.log("<<<<<<<<<<<<>>>>>>>>>>>>>>>>>>", response.Data)
          this.$root.$emit('projectName', response.Data.projectName)
          this.$store.dispatch('SetLoader', {status: false, message: 'Please Wait...'})
          // this.$store.dispatch('SetAlert', {showAlert: true, message: response.message, color: 'success'})
        },
        error => {
          // console.log(error)
          this.$store.dispatch('SetLoader', {status: false, message: 'Please Wait...'})
          this.$store.dispatch('SetAlert', {showAlert: true, message: error.message, color: 'error'})
        }
      )
    },
    getEmployeeList () {
      this.$store.dispatch('SetLoader', {status: true, message: 'Loading...'})
      HRMAPI.getProjectPageList(
        this.filterObject.start,
        this.filterObject.length,
        this.searchForCustomer,
        this.filterObject.sortBy,
        this.filterObject.sortOrder,
        this.filterObject.isActive,
        parseInt(this.$route.params.projectId),
        response => {
          console.log("response", response.Data)
          this.resetPaginationValues = false
          let employeeList = response.Data.tableRow === null ? [] : response.Data.tableRow
          for (let index = 0; index < employeeList.length; index++) {
            employeeList[index].isOpen = false
          }
          this.employeeList = employeeList
          this.totalEmpCount = response.Data.count
          console.log('count', this.totalEmpCount)
          this.searchLoader = false
          this.$store.dispatch('SetLoader', {status: false, message: ''})
        },
        error => {
          this.$store.dispatch('SetLoader', {status: false, message: ''})
          this.$store.dispatch('SetAlert', {showAlert: true, message: error.message, color: 'error'})
        }
      )
    }
  },
  beforeDestroy () {
    this.clearRetry()
    localStorage.removeItem('filterDataOfEmployee')
    this.$root.$off('Filter')
    this.$root.$off('Filters')
  }
}
</script>
<style scoped>
.table_containder {
  padding: 1px;
}
.name_col {
  min-width: 500px !important;
  width: 500px !important;
  overflow-wrap: anywhere;
  white-space: pre-wrap;
  padding-right: 8px;
}
.id_col {
  min-width: 150px !important;
  width: 150px !important;
  overflow-wrap: anywhere;
  white-space: pre-wrap;
  padding-right: 8px;
}
.cell_col {
  min-width: 320px !important;
  width: 320px !important;
  overflow-wrap: anywhere;
  white-space: pre-wrap;
  padding-right: 8px;
}
.list_btn {
  min-width: 77px !important;
  max-width: 77px;
}
.select_btn {
  min-width: 77px !important;
  max-width: 77px;
}
.select_btn:focus-visible {
  outline: none;
}
.search_customer_box {
  min-width: 335px !important;
  max-width: 335px !important;
}
.list_top_card_btn {
  width: 183px !important;
  margin-right: 15px !important;
}
.row_user_svg {
  height: 36px;
  width: 36px;
}
.navbar-open {
  transform: translateX(0%);
}
.navbar-close {
  transform: translateX(-100%);
}
.demo-container {
  width: 300px;
  margin: auto;
}

.progress-bar {
  height: 2px;
  background-color: rgb(18,149,186);
  width: 100%;
  overflow: hidden;
}

.progress-bar-value {
  width: 100%;
  height: 100%;
  background-color: rgb(121, 200, 221);
  animation: indeterminateAnimation 2s infinite linear;
  transform-origin: 0% 50%;
}

@keyframes indeterminateAnimation {
  0% {
    transform:  translateX(0) scaleX(0);
  }
  40% {
    transform:  translateX(0) scaleX(0.4);
  }
  100% {
    transform:  translateX(100%) scaleX(0.5);
  }
}
::placeholder {
  font-size: 16px;
}
.lableWidth {
  width: 105px;
}
.dotwidth {
  width: 15px;
}
.loader {
  border: 3px solid #f3f3f3;
  border-radius: 50%;
  border-top: 3px solid #307dea;
  width: 27px;
  height: 27px;
  -webkit-animation: spin 2s linear infinite; /* Safari */
  animation: spin 2s linear infinite;
}

/* Safari */
@-webkit-keyframes spin {
  0% { -webkit-transform: rotate(0deg); }
  100% { -webkit-transform: rotate(360deg); }
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
</style>
